import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Grid, Text } from 'components/ui';
import ProductImage from 'components/Product/ProductImage/ProductImage';
import BccUtils from 'utils/BCC';
import skuUtils from 'utils/Sku';

const { IMAGE_SIZES } = BccUtils;

function ProductDetails({ product }) {
    const productDetails = product.productDetails;
    const sku = product.currentSku || product;

    const sizeVariation = sku?.size ? `Size ${sku.size}` : '';
    const colorVariation = sku?.variationType === skuUtils.skuVariationType.COLOR ? `Color: ${sku.variationValue}` : '';
    const variationString = `${sizeVariation}${sizeVariation && colorVariation ? ' • ' : ''}${colorVariation}`;

    return (
        <Grid
            columns={['auto 1fr', 1]}
            gap={4}
            lineHeight='tight'
            alignItems='center'
        >
            <ProductImage
                id={sku?.skuId}
                size={[IMAGE_SIZES[97], IMAGE_SIZES[162]]}
                skuImages={sku?.skuImages}
                disableLazyLoad={true}
            />
            <Grid
                columns={1}
                gap={[1, 0]}
            >
                <Text
                    display='block'
                    fontWeight='bold'
                    data-at={Sephora.debug.dataAt('ropis_sku_brand')}
                >
                    {productDetails?.brand ? productDetails.brand.displayName : productDetails?.brandName}
                </Text>
                <Text data-at={Sephora.debug.dataAt('ropis_sku_name')}>{productDetails?.displayName}</Text>
                {variationString && (
                    <Text
                        color='gray'
                        display='block'
                        fontSize='sm'
                        data-at={Sephora.debug.dataAt('ropis_sku_var')}
                    >
                        {variationString}
                    </Text>
                )}
            </Grid>
        </Grid>
    );
}

export default wrapFunctionalComponent(ProductDetails, 'ProductDetails');
